export enum MemberType {
    client = 0,
    staff = 1
}